import { PLATFORM_ID, Inject, Injector, Directive } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import * as signalR from "@microsoft/signalr";

@Directive()
export class SignalrNotificationHub {
    globalConnections = [];
    @Inject(Injector) injector: any;
    initNewConnection(options) {

        let connection = null;
        if (isPlatformServer(this.platformId)) return connection;

        if (options && options.rootPath) {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(options.rootPath + '/NotifierServerHub')
                .build();
        } else {
            connection = new signalR.HubConnectionBuilder();
        }
        connection.logging = (options && options.logging ? true : false);
        return connection;
    }

    getConnection(options) {
        let useSharedConnection = !(options && options.useSharedConnection === false);
        if (useSharedConnection) {
            return typeof this.globalConnections[options.rootPath] === 'undefined' ?
                this.globalConnections[options.rootPath] = this.initNewConnection(options) :
                this.globalConnections[options.rootPath];
        }
        else {
            return this.initNewConnection(options);
        }
    }

    constructor(public hubName, public options, @Inject(PLATFORM_ID) private platformId?: Object) {
        let Hub: any = {
            connection: null,
            proxy: null,
            on: null,
            invoke: null,
            disconnect: null,
            reconnect: null,
            connect: null,
            promise: null
        };

        if (isPlatformServer(this.platformId)) return Hub;

        let data = this.getConnection(options);
        Hub.connection = data;

        Hub.on = function (event, fn) {
            Hub.connection.on(event, fn);
        };

        Hub.disconnect = function () {
            Hub.connection.stop();
        };
        Hub.reconnect = function (callback) {
            return Hub.connection.start().done(function (response) {
                //console.log('ReConnected, transport = ' + response.transport.name);
                callback();
            });
        };
        Hub.invoke = function (method, args) {
            return Hub.connection.invoke.apply(Hub.connection, arguments)
        };

        return Hub;
    }
}
